export default __webpack_public_path__ + "static/media/app.eb0d3086.png";